import { BundleProps, ProductData } from 'utils/types';
import { CSSProperties, useEffect, useMemo, useState } from 'react';
import { TooltipTemplate } from 'components/TooltipTemplate';
import { IExtendedTooltipProps } from 'components/TooltipTemplate/types';

interface ITooltipRendererProps {
  product: ProductData;
  tooltipLoadCallback?: BundleProps['tooltipLoadCallback'];
  tooltipOpenEventHandler?: BundleProps['tooltipOpenEventHandler'];
  simpleTooltipStyle?: CSSProperties;
  advancedTooltipStyle?: CSSProperties;
  buttonStyle: CSSProperties;
}

export const TooltipRenderer: React.FC<ITooltipRendererProps> = ({
  product,
  tooltipLoadCallback,
  tooltipOpenEventHandler,
  simpleTooltipStyle,
  advancedTooltipStyle,
  buttonStyle,
  children,
}) => {
  const [tooltipContent, setTooltipContent] = useState<
    string | IExtendedTooltipProps | null
  >(null);

  useEffect(() => {
    if (product?.rarityProductInfo?.tooltipText) {
      setTooltipContent(product.rarityProductInfo?.tooltipText);
    } else if (product?.rarityProductInfo?.tooltip?.length > 0) {
      const tooltip = product.rarityProductInfo.tooltip;
      setTooltipContent({
        sections: tooltip,
        titleImg: product?.images?.product,
        title: product?.displayName || '',
        tooltipLoadCallback: tooltipLoadCallback,
      });
    }
  }, [product, tooltipLoadCallback]);

  const isSimpleTooltip = useMemo(
    () => typeof tooltipContent === 'string',
    [tooltipContent],
  );

  if (!tooltipContent) return <></>;

  return (
    <TooltipTemplate
      buttonStyle={buttonStyle}
      content={tooltipContent}
      templateTooltipStyle={
        isSimpleTooltip ? simpleTooltipStyle : advancedTooltipStyle
      }
      tooltipOpenEventHandler={tooltipOpenEventHandler}
    >
      {children}
    </TooltipTemplate>
  );
};
